/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TravelineAddressDto } from './traveline-address-dto';
import {
    TravelineAddressDtoFromJSON,
    TravelineAddressDtoFromJSONTyped,
    TravelineAddressDtoToJSON,
    TravelineAddressDtoToJSONTyped,
} from './traveline-address-dto';
import type { TravelinePhoneDto } from './traveline-phone-dto';
import {
    TravelinePhoneDtoFromJSON,
    TravelinePhoneDtoFromJSONTyped,
    TravelinePhoneDtoToJSON,
    TravelinePhoneDtoToJSONTyped,
} from './traveline-phone-dto';

/**
 * Contact details entity of a property
 * @export
 * @interface TravelineContactInfoDto
 */
export interface TravelineContactInfoDto {
    /**
     * 
     * @type {TravelineAddressDto}
     * @memberof TravelineContactInfoDto
     */
    address: TravelineAddressDto;
    /**
     * (Planned) Property phone numbers
     * @type {Array<TravelinePhoneDto>}
     * @memberof TravelineContactInfoDto
     */
    phones?: Array<TravelinePhoneDto> | null;
    /**
     * (Planned) Hotel email addresses
     * @type {Array<string>}
     * @memberof TravelineContactInfoDto
     */
    emails?: Array<string> | null;
}

/**
 * Check if a given object implements the TravelineContactInfoDto interface.
 */
export function instanceOfTravelineContactInfoDto(value: object): value is TravelineContactInfoDto {
    if (!('address' in value) || value['address'] === undefined) return false;
    return true;
}

export function TravelineContactInfoDtoFromJSON(json: any): TravelineContactInfoDto {
    return TravelineContactInfoDtoFromJSONTyped(json, false);
}

export function TravelineContactInfoDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineContactInfoDto {
    if (json == null) {
        return json;
    }
    return {
        
        'address': TravelineAddressDtoFromJSON(json['address']),
        'phones': json['phones'] == null ? undefined : ((json['phones'] as Array<any>).map(TravelinePhoneDtoFromJSON)),
        'emails': json['emails'] == null ? undefined : json['emails'],
    };
}

  export function TravelineContactInfoDtoToJSON(json: any): TravelineContactInfoDto {
      return TravelineContactInfoDtoToJSONTyped(json, false);
  }

  export function TravelineContactInfoDtoToJSONTyped(value?: TravelineContactInfoDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'address': TravelineAddressDtoToJSON(value['address']),
        'phones': value['phones'] == null ? undefined : ((value['phones'] as Array<any>).map(TravelinePhoneDtoToJSON)),
        'emails': value['emails'],
    };
}

